import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/system/Container';
import Master from 'front/MasterAdmin';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { hasErrors } from '../../../common/enums';
import { Territory } from '../../../common/models/territories';
import { selectTerritoriesAdministration } from '../../../common/selectors/territories';
import { userLogged } from '../../../common/selectors/user';
import { adminSlice } from '../../../common/store/admin';
import { AppState, appStore, franchiseSelector } from '../../../common/store/store';
import { territorySlice } from '../../../common/store/territories';
import { postData } from '../../api';

const TerritoryItem = (props: { territory: Territory; }) => {

    const relatedFranchise = useSelector((state: AppState) => franchiseSelector.selectById(state, props.territory.franchiseId ?? 0));

    const navigate = useNavigate();

    return <ListItemButton onClick={() => { navigate('/admin/territoire/' + props.territory.id); }}>
        <ListItemText
            primary={<>{props.territory.name} <Chip label={props.territory.regions.length + ' zone(s)'} /></>}
            secondary={relatedFranchise ? relatedFranchise.name : 'Aucune franchise lié'}
        />
    </ListItemButton>;
};

export const Territoires = () => {

    const territories = useSelector((state: AppState) => selectTerritoriesAdministration(state));
    const user = useSelector((state: AppState) => userLogged(state));

    const newTerritory = useSelector((state: AppState) => state.admin.newTerritory);
    const [err, setErr] = React.useState<ResponseError[] | undefined>();

    const onAjouterClick = async () => {
        const response = await postData<Territory>('territories', newTerritory);
        if (hasErrors(response)) {
            setErr(response);
        } else {
            setErr(undefined);
            appStore.dispatch(territorySlice.actions.addOne(response));
            appStore.dispatch(adminSlice.actions.updateNewTerritory({ name: '' }));

        }
    };

    return <Master><Container maxWidth={false}>
        <Typography variant={'h1'}>Territoires</Typography>
        <Typography>Cette liste correspond à celle proposée dans le formulaire de contact</Typography>
        <List>
            {territories.map(ae => <TerritoryItem key={ae.id} territory={ae} />)}
        </List>
        {user?.isAdmin === true ?
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Box sx={{ flexGrow: 1 }}>
                    <TextField
                        fullWidth
                        value={newTerritory.name}
                        onChange={(event) => {
                            appStore.dispatch(adminSlice.actions.updateNewTerritory({ name: event.target.value }));
                        }}
                        type='text'
                        required
                        size='small'
                        sx={{ width: '100%' }}
                        error={!!err?.find(p => p.param == 'name')}
                        helperText={err?.find(p => p.param == 'name')?.msg}
                        placeholder='Nom du territoire' />
                </Box>
                <Box>
                    <Button
                        disabled={newTerritory.name == ''}
                        size='small'
                        variant='contained'
                        onClick={onAjouterClick}>Ajouter</Button>
                </Box>
            </Box> : null}
    </Container></Master>
        ;
};
